var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Table } from "primeng/table";
import { UserRoles, } from "../../shared/services/current-user.service";
import { RequestStatusEnum } from "../../shared/services/request-status.service";
import { AlertService } from "../../shared/services/alert.service";
import { LoadingWrapperService } from "../../shared/services/loading-wrapper.service";
import { finalize } from "rxjs/operators";
import { FileSaverService } from "../../shared/services/file-saver.service";
import { format } from "date-fns";
import { RequestGridService, RequestGridSortField, } from "../../shared/services/request-grid.service";
import { RequestService } from "../../shared/services/request.service";
import { YesNoPipe } from "../../shared/pipes/yesNo.pipe";
var RequestListComponent = /** @class */ (function () {
    function RequestListComponent(alertService, loadingService, requestService, requestGridService, fileSaverService) {
        this.alertService = alertService;
        this.loadingService = loadingService;
        this.requestService = requestService;
        this.requestGridService = requestGridService;
        this.fileSaverService = fileSaverService;
        this.displayedRequests = [];
        this.selectedRequests = [];
        this.isLoading = true;
        this.requestCount = 0;
        this.currentPage = 0;
        this.firstIndexInPage = 0;
        this.numberOfRowsPerPage = 15;
        this.editRoles = UserRoles.Requestor |
            UserRoles.CollaboratorLiaison |
            UserRoles.TacticalLiaison |
            UserRoles.ExperimentCreator;
        this.yesNoDropdownOptions = [
            { label: "", value: null },
            { label: "Yes", value: true },
            { label: "No", value: false },
        ];
        this.requestStatusDropdownOptions = [];
        this.requestPurposeDropdownOptions = [];
    }
    Object.defineProperty(RequestListComponent.prototype, "areTableOperationsEnabled", {
        get: function () {
            return this.selectedRequests && this.selectedRequests.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    RequestListComponent.prototype.ngOnInit = function () {
        this.cols = [
            { field: "requestNumber", header: "Request #", sortable: true },
            { field: "title", header: "Experiment Title", sortable: true },
            { field: "status", header: "Status", sortable: false },
            { field: "requester", header: "Requester", sortable: false },
            { field: "delegate", header: "Delegate", sortable: false },
            { field: "tacticalLiaison", header: "Assigned To", sortable: false },
            { field: "crop", header: "Crop", sortable: false },
            { field: "plantDate", header: "Plant Date", sortable: true },
            { field: "requestPurpose", header: "Purpose", sortable: false },
            { field: "isSamplingRequired", header: "Sampling?", sortable: false },
            { field: "isRecurringRequest", header: "Recurring?", sortable: false },
        ];
        var orderedRequestStatuses = this.requestOptions.requestStatuses.sort(function (a, b) { return a.order - b.order; });
        this.requestStatusDropdownOptions = orderedRequestStatuses.map(function (s) {
            return ({
                label: s.name,
                value: s.id,
            });
        });
        this.requestPurposeDropdownOptions =
            this.requestOptions.requestPurposes.map(function (s) {
                return ({
                    label: s.name,
                    value: s.id,
                });
            });
    };
    RequestListComponent.prototype.loadRequests = function (event) {
        var _this = this;
        var sortField = RequestGridSortField[event.sortField] || RequestGridSortField.plantDate;
        var criteria = {
            skip: event.first,
            take: event.rows,
            sortField: sortField,
            sortOrder: event.sortOrder,
        };
        if (event.filters) {
            criteria.requestNumber =
                event.filters.requestNumber && event.filters.requestNumber.value;
            criteria.title = event.filters.title && event.filters.title.value;
            criteria.statusIds = event.filters.status && event.filters.status.value;
            criteria.requester =
                event.filters.requester && event.filters.requester.value;
            criteria.delegate =
                event.filters.delegate && event.filters.delegate.value;
            criteria.tacticalLiaison =
                event.filters.tacticalLiaison && event.filters.tacticalLiaison.value;
            criteria.crop = event.filters.crop && event.filters.crop.value;
            criteria.purposeIds =
                event.filters.requestPurpose && event.filters.requestPurpose.value;
            criteria.isRecurringRequest =
                event.filters.isRecurringRequest &&
                    event.filters.isRecurringRequest.value;
            criteria.isSamplingRequired =
                event.filters.isSamplingRequired &&
                    event.filters.isSamplingRequired.value;
        }
        if (this.dateRange) {
            criteria.plantStartDate = this.dateRange[0];
            criteria.plantEndDate = this.dateRange[1];
        }
        this.isLoading = true;
        this.requestGridService
            .query(criteria)
            .pipe(finalize(function () { return (_this.isLoading = false); }))
            .subscribe(function (response) {
            _this.displayedRequests = response.data.map(function (r) { return (__assign({}, r, { status: _this.getStatus(r), requester: _this.getUserName(r.requesterId), delegate: _this.getUserName(r.delegateId), tacticalLiaison: _this.getUserName(r.tacticalLiaisonId), crop: _this.getCropName(r.cropId), requestPurpose: _this.getRequestPurposeName(r.requestPurposeId) })); });
            _this.requestCount = response.totalCount;
        }, function (err) {
            _this.alertService.error("Unable to load Requests");
        });
    };
    RequestListComponent.prototype.printPlantingCards = function () {
        var _this = this;
        var _a = [
            this.dataTable.sortField,
            this.dataTable.sortOrder,
        ], sortField = _a[0], sortOrder = _a[1];
        var yesNoPipe = new YesNoPipe();
        var requestIds = this.selectedRequests
            .sort(function (request1, request2) {
            var prop1 = request1[sortField];
            var prop2 = request2[sortField];
            var difference = 0;
            if (prop1 == null && prop2 != null) {
                difference = -1;
            }
            else if (prop1 != null && prop2 == null) {
                difference = 1;
            }
            else if (prop1 == null && prop2 == null) {
                difference = 0;
            }
            else if (typeof prop1 === "string" && typeof prop2 === "string") {
                difference = prop1.localeCompare(prop2);
            }
            else if (prop1 instanceof Date && prop2 instanceof Date) {
                difference = prop1.getTime() - prop2.getTime();
            }
            else if (typeof prop1 === "number" && typeof prop2 === "number") {
                difference = prop1 - prop2;
            }
            else if (typeof prop1 === "boolean" && typeof prop2 === "boolean") {
                var prop1String = yesNoPipe.transform(prop1);
                var prop2String = yesNoPipe.transform(prop2);
                difference = prop1String.localeCompare(prop2String);
            }
            if (difference === 0) {
                difference = request1.id - request2.id;
            }
            return sortOrder * difference;
        })
            .map(function (request) { return request.id; });
        this.loadingService.setMessage("Printing Planting Cards...");
        this.requestService
            .getPlantingCards(requestIds)
            .pipe(finalize(function () {
            _this.loadingService.clearMessage();
            _this.selectedRequests = [];
        }))
            .subscribe(function (plantingCardsFile) {
            _this.fileSaverService.save(plantingCardsFile);
            _this.alertService.success("Planting Card Download Complete!");
        }, function (errorResponse) {
            _this.alertService.error("Error retreiving Planting Cards. " + errorResponse.error + ".");
        });
    };
    RequestListComponent.prototype.onPageChange = function (event) {
        this.firstIndexInPage = event.first;
        this.numberOfRowsPerPage = event.rows;
        this.currentPage = this.firstIndexInPage / this.numberOfRowsPerPage;
        this.selectedRequests = [];
    };
    RequestListComponent.prototype.resetCurrentPage = function () {
        this.firstIndexInPage = 0;
        this.currentPage = 0;
        this.selectedRequests = [];
    };
    RequestListComponent.prototype.onSelectedRequestsChange = function (selectedRequests) {
        var _this = this;
        var filteredRequests = selectedRequests.slice();
        // Only select current page if select all button is clicked.
        if (filteredRequests.length > this.numberOfRowsPerPage) {
            var startIndex = this.currentPage * this.numberOfRowsPerPage;
            var endIndex = startIndex + this.numberOfRowsPerPage;
            filteredRequests = filteredRequests.slice(startIndex, endIndex);
        }
        this.selectedRequests = filteredRequests.filter(function (request) {
            return _this.allowPlantingCardPrintingForRequest(request);
        });
    };
    RequestListComponent.prototype.allowPlantingCardPrintingForRequest = function (request) {
        var validRequestStatuses = [
            RequestStatusEnum.ReadyForReview,
            RequestStatusEnum.Reviewed,
            RequestStatusEnum.CreatingExperiment,
            RequestStatusEnum.ExperimentInProgress,
            RequestStatusEnum.Pollination,
            RequestStatusEnum.Harvest,
            RequestStatusEnum.PlantedInFlat,
        ];
        return validRequestStatuses.some(function (status) { return status === request.statusId; });
    };
    RequestListComponent.prototype.getEditLink = function (id) {
        return "/requests/edit/" + id;
    };
    RequestListComponent.prototype.getViewLink = function (id) {
        return "/requests/view/" + id;
    };
    RequestListComponent.prototype.getStatus = function (request) {
        var displayDateStatuses = [
            RequestStatusEnum.Pollination,
            RequestStatusEnum.Harvest,
            RequestStatusEnum.PlantedInFlat,
        ];
        if (displayDateStatuses.includes(request.statusId)) {
            var date = request.latestStatusChangeDate
                ? format(request.latestStatusChangeDate, "M/D/YY")
                : "";
            return this.requestOptions.requestStatusDitionary[request.statusId].name + " - " + date;
        }
        else {
            return this.requestOptions.requestStatusDitionary[request.statusId].name;
        }
    };
    RequestListComponent.prototype.getUserName = function (userId) {
        var user = this.requestOptions.userDictionary[userId];
        if (user) {
            return user.surname + ", " + user.givenName;
        }
        return "";
    };
    RequestListComponent.prototype.getCropName = function (cropId) {
        var crop = this.requestOptions.cropDictionary[cropId];
        if (crop) {
            return crop.name;
        }
        return "";
    };
    RequestListComponent.prototype.getRequestPurposeName = function (requestPurposeId) {
        var requestPurpose = this.requestOptions.requestPurposeDictionary[requestPurposeId];
        if (requestPurpose) {
            return requestPurpose.name;
        }
        return "";
    };
    return RequestListComponent;
}());
export { RequestListComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-list/request-list.component.ts.pre-build-optimizer.js